/* RESPONSIBLE TEAM: team-phone */

export type FinVoiceRunbookOptions = {
  value: FinVoiceRunbook;
  text: string;
};

export type FinVoiceRunbook =
  | 'none'
  | 'card_reader_troubleshooting'
  | 'flex_terminal_card_reader'
  | 'damaged_card_reader';

export const FIN_VOICE_RUNBOOK_OPTIONS: FinVoiceRunbookOptions[] = [
  { value: 'none', text: 'ai-agent.voice-playground.settings.runbook-none' },
  {
    value: 'card_reader_troubleshooting',
    text: 'ai-agent.voice-playground.settings.runbook-card-reader-troubleshooting',
  },
  {
    value: 'flex_terminal_card_reader',
    text: 'ai-agent.voice-playground.settings.runbook-flex-terminal-card-reader',
  },
  {
    value: 'damaged_card_reader',
    text: 'ai-agent.voice-playground.settings.runbook-damaged-card-reader',
  },
];
